import React from 'react';
import withTranslations from 'app/components/HOGs/withTranslations';

const TTOTitle = ({ tr }) => {
  const title = tr['Tourstart Tour Optimizer'];

  return <div className="tto_layout">{title}</div>;
};

export default withTranslations(TTOTitle);
